import React from 'react';

import logo from '../../assets/ECOOPS LOGO_NEW.png';

const AdminLogoHeader = () => (
  <header className="bg-white shadow-sm">
    <div className="max-w-7xl mx-auto flex flex-col gap-2 md:flex-row md:items-center md:justify-between px-6 py-4">
      <div className="flex items-center gap-4">
        <img src={logo} alt="ECOOPS Financial Services Limited" className="h-14 w-auto" />
        <div>
          <p className="text-xl font-semibold text-slate-900">ECOOPS Admin Console</p>
          <p className="text-sm text-slate-500">Financial Services Limited &mdash; RC: 1723240</p>
        </div>
      </div>
    </div>
  </header>
);

export default AdminLogoHeader;
